import numeral from 'numeral'

const formatter = {
    Price: {
        format: (amount, format = '0,0') => numeral(amount).format(format)
    }
}

export default formatter